import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../../navigations/RootNavigation";
import Text from "../../../components/Text";
import { useCallback, useContext, useMemo } from "react";
import * as Notifications from "expo-notifications";
import { useTheme } from "../../../hooks/use-theme";
import { useI18n } from "../../../hooks/i18n-hooks";
import { Platform, StyleSheet } from "react-native";
import ScreenCard from "../../ScreenCard";
import { WelcomeCarousel } from "../../../components/WelcomeCarousel";
import IconButton from "../../../components/IconButton";
import { SafeAreaManagerContext } from "../../../contexts/SafeAreaManager";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useFocusEffect } from "@react-navigation/core";

export type PresentationCarouselScreenProps = StackScreenProps<
    RootStackParamList,
    "PresentationCarousel"
>;

const PresentationCarouselScreen = ({ navigation }: PresentationCarouselScreenProps) => {
    const i18n = useI18n();
    const styles = useStyles();

    const goToPhoneNumberOrAskNotifications = useCallback(async () => {
        if (Platform.OS === "ios") {
            await Notifications.requestPermissionsAsync({
                ios: {
                    allowProvisional: true,
                },
            });
        }

        navigation.navigate("SignupSigninStack", { isSignup: true });
    }, [navigation]);

    const { setStatusBarTranslucent } = useContext(SafeAreaManagerContext);

    useFocusEffect(
        useCallback(() => {
            setStatusBarTranslucent(false);
            return () => {
                setStatusBarTranslucent(true);
            };
        }, [setStatusBarTranslucent]),
    );

    const insets = useSafeAreaInsets();

    return (
        <ScreenCard
            buttons={[
                {
                    title: i18n.t("screens.auth.presentation_carousel.create_my_account"),
                    mode: "secondary",
                    onPress: goToPhoneNumberOrAskNotifications,
                },
            ]}
            style={{ overflow: "visible" }}
            contentStyle={{ overflow: "visible" }}
            contentContainerStyle={{
                flex: 1,
                height: "100%",
                overflow: "visible",
            }}
            noBottomBlur
        >
            <WelcomeCarousel />
            <IconButton
                style={[styles.closeButton, { marginTop: insets.top }]}
                onPress={navigation.goBack}
                size={30}
                icon="close"
            />
        </ScreenCard>
    );
};

const useStyles = () => {
    const { gridSize } = useTheme();
    return useMemo(
        () =>
            StyleSheet.create({
                closeButton: {
                    position: "absolute",
                    right: gridSize / 1.5,
                    top: gridSize / 1.5,
                    zIndex: 1000,
                },
            }),
        [gridSize],
    );
};

export default PresentationCarouselScreen;
